import axios from "axios";
import { ISearchRequest, ISearchBudget, ISearchSingle } from "./models";

export const storesApi = {
  search(req: ISearchRequest) {
    const url =
      "https://bzzz17duba.execute-api.ap-northeast-1.amazonaws.com/phase1/search/by-entities";
    return axios.post(url, req);
  },
  searchByBudget(req: ISearchBudget) {
    const url =
      "https://bzzz17duba.execute-api.ap-northeast-1.amazonaws.com/phase1/search/by-budget";
    return axios.post(url, req);
  },
  listStoreSingle(req: ISearchSingle) {
    const url =
      "https://mp40d9i3ha.execute-api.ap-northeast-1.amazonaws.com/phase1/single-entity";
    return axios.post(url, req);
  },
  getById(id: string) {
    const req = {
      store_id: id,
    };
    const url =
      "https://bzzz17duba.execute-api.ap-northeast-1.amazonaws.com/phase1/store/info";
    return axios.post(url, req);
  },
};
